import { Component, OnInit } from '@angular/core'; // Retire ViewChild, ElementRef, AfterViewInit

import { RouterModule } from '@angular/router';
import { Observable, finalize, map } from 'rxjs';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { AvatarComponent } from '../../_utils/components/avatar/avatar.component';
import { TeamFormComponent } from '../team-form/team-form.component';
import { Team, TeamAdapter } from '../../models/team';
import { TeamsService } from '../../services/teams.service';
import { ToastService } from '../../services/toast.service';

// Retire la déclaration 'bootstrap'
// declare const bootstrap: any;


@Component({
  selector: 'app-team-list',
  standalone: true,
  imports: [
    ConfirmDialogComponent,
    RouterModule,
    TranslatePipe,
    AvatarComponent,
    TeamFormComponent
],
  templateUrl: './team-list.component.html',
  styleUrl: './team-list.component.scss',
})
export class TeamListComponent implements OnInit {
  teams: Team[] = [];
  teamToEdit: Team | null = null;
  teamToDelete!: Team;
  showConfirmDialog: boolean = false;
  warningMessagesConfirmDialog: string[] = [];
  showTeamForm: boolean = false; // Pour contrôler l'affichage du tiroir
  isLoading: boolean = false;

  private teamsObservable!: Observable<Team[]>;

  constructor(
    private teamsService: TeamsService,
    private teamsAdapter: TeamAdapter,
    private translate: TranslateService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.fetchTeams();
  }


  fetchTeams(): void {
    this.isLoading = true;
    this.teamsObservable = this.teamsService.getTeams().pipe(
        map((data: any[]) => data.map((item) => this.teamsAdapter.adapt(item))),
        finalize(() => this.isLoading = false)
      );

    this.teamsObservable.subscribe((teams: Team[]) => {
      this.teams = teams;
    });
  }

  /**
   * Gère la soumission du formulaire d'équipe (ajout ou modification).
   * @param team L'objet Team soumis par le TeamFormComponent.
   */
  handleFormSubmission(team: Team): void {
    if (team.id === 0) {
      const teamToAdd = new Team(
        0,
        team.name,
        team.description,
        new Date(),
        new Date(),
        team.skills,
        team.roles,
        team.teamType
      );
      this.teamsService.addTeam(this.teamsAdapter.adaptToApi(teamToAdd)).subscribe({
        next: () => {
          this.fetchTeams();
          this.hideTeamForm(); 
          this.toastService.showSuccess('COMMON.ADD_SUCCESS');
        },
        error: (err) => {
          this.toastService.showError('COMMON.SAVE_ERROR');
        }
      });
    } else {
      this.teamsService.updateTeam(this.teamsAdapter.adaptToApi(team)).subscribe({
        next: () => {
          this.fetchTeams();
          this.hideTeamForm(); 
          this.toastService.showSuccess('COMMON.UPDATE_SUCCESS');
        },
        error: (err) => {
          this.toastService.showError('COMMON.SAVE_ERROR');
        }
      });
    }
  }

  /**
   * Appelé lorsque l'utilisateur clique sur le bouton "Ajouter une nouvelle équipe".
   */
  addNewTeam(): void {
    this.teamToEdit = null; // Indique au TeamFormComponent qu'il s'agit d'un ajout
    this.showTeamForm = true; // Ouvre le formulaire/tiroir via classe Bootstrap 'show'
  }

  /**
   * Appelé lorsque l'utilisateur clique sur le bouton "Éditer" pour une équipe existante.
   * @param team L'équipe à éditer.
   */
  editTeam(team: Team): void {
    this.teamToEdit = team; // Passe l'équipe à éditer au TeamFormComponent
    this.showTeamForm = true; // Ouvre le formulaire/tiroir via classe Bootstrap 'show'
  }

  /**
   * Gère l'annulation du formulaire par l'utilisateur.
   */
  onCancelForm(): void {
    this.hideTeamForm(); // Ferme le formulaire/tiroir en modifiant l'état Angular
  }

  confirmDelete(team: Team): void {
    this.teamToDelete = team;
    this.getDeleteWarning();
    this.showConfirmDialog = true;
  }

  handleConfirm(result: boolean): void {
    if (result) {
      this.deleteTeam(this.teamToDelete);
    }
    this.showConfirmDialog = false;
  }

  deleteTeam(team: Team): void {
    this.teamsService.deleteTeam(team.id).subscribe(() => {
      this.teams = this.teams.filter((t) => t.id !== team.id);
    });
  }

  /**
   * Masque le formulaire d'équipe et réinitialise l'équipe en édition.
   * Cette méthode est appelée lors de la soumission, de l'annulation ou
   * lorsque l'utilisateur ferme le tiroir via l'interface Bootstrap.
   */
  hideTeamForm(): void {
    this.showTeamForm = false; // Met à jour l'état Angular pour cacher le tiroir
    this.teamToEdit = null; // Réinitialise l'équipe en édition
  }

  private getDeleteWarning(){
    if(this.teamToDelete.peoples.length > 0){
      const warningMessage = this.translate.instant('TEAM.WARNINGS.TEAM_ASSSIGNATIONS_DELETION');
      this.warningMessagesConfirmDialog.push(warningMessage);
    }
  }
}